import script from "./StatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusBadge.vue?vue&type=script&setup=true&lang=ts"

import "./StatusBadge.vue?vue&type=style&index=0&id=1305b24d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1305b24d"]])

export default __exports__